import { getMemberTypeFromBoard } from './getMemberTypeFromBoard';
import { getMyBoards } from './getMyBoards';

export const getMyOwnedBoards = <
  TMember extends {
    id: string;
    idBoards: Array<string>;
    idEnterprisesAdmin: Array<string>;
    idPremOrgsAdmin: Array<string>;
    memberType: 'ghost' | 'normal';
  } & {
    boards: {
      id: string;
      memberships: {
        id: string;
        deactivated: boolean;
        idMember: string;
        memberType: 'admin' | 'normal' | 'observer';
        unconfirmed: boolean;
      }[];
      organization?:
        | ({ id: string; offering: string } & {
            memberships: {
              deactivated: boolean;
              idMember: string;
              memberType: 'admin' | 'normal';
              unconfirmed: boolean;
            }[];
            enterprise?: { idAdmins: Array<string> } | null;
          })
        | null;
    }[];
  },
>(
  member: TMember,
): TMember['boards'] => {
  return getMyBoards(member).filter(
    (board) =>
      getMemberTypeFromBoard(member, board, board?.organization) === 'admin',
  );
};
